module.exports = __webpack_public_path__ + "static/media/visa.36d40296.svg";